const WORKFLOW_ID_STORAGE_KEY = 'lyt.portal.workflow_id';

/**
 * Create a UUID for journey correlation. Prefer crypto.randomUUID when available.
 *
 * @returns {string}
 */
export const createWorkflowId = () => {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
        return `wf_${crypto.randomUUID()}`;
    }

    // Fallback for older environments / tests without crypto.randomUUID.
    return `wf_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
};

/**
 * Return the tab-scoped workflow id, creating and persisting one if needed.
 * Uses sessionStorage so a refresh in the same tab keeps the same journey id.
 *
 * @returns {string}
 */
export const getOrCreateWorkflowId = () => {
    try {
        if (typeof sessionStorage !== 'undefined') {
            const existing = sessionStorage.getItem(WORKFLOW_ID_STORAGE_KEY);
            if (existing) {
                return existing;
            }

            const created = createWorkflowId();
            sessionStorage.setItem(WORKFLOW_ID_STORAGE_KEY, created);
            return created;
        }
    } catch {
        // sessionStorage can throw (private mode / blocked); fall through.
    }

    return createWorkflowId();
};

/**
 * Test helper — clear persisted workflow id.
 */
export const __resetWorkflowIdForTests = () => {
    try {
        if (typeof sessionStorage !== 'undefined') {
            sessionStorage.removeItem(WORKFLOW_ID_STORAGE_KEY);
        }
    } catch {
        // ignore
    }
};
